import { createFileRoute } from '@tanstack/react-router'

import { ReasonsPage } from '#/modules/catalog/reasons-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/shipment-reasons')({
  component: ReasonsPage,
  validateSearch: validateListSearch,
})
